import { ApplicationState } from 'app/types-store';

export const selectImportCaseDetails = (state: ApplicationState) => 
  state.import?.importCaseDetails;
